import { Reveal, SectionHead, Counter } from "./shared";
import { IMAGES, STATS } from "../data/content";

const QUICK_FACTS = [
    { k: "Who We Are", v: "An electrical infrastructure and power-sector contracting company, established 1997." },
    { k: "What We Do", v: "Transmission lines, substations, substation O&M, renewable energy and associated civil works." },
    { k: "Where We Operate", v: "Maharashtra, Karnataka and Andhra Pradesh." },
];

export const About = () => (
    <section id="about" data-testid="about-section" className="relative bg-white py-16 lg:py-32">
        <div className="vec-container">
            <div className="grid grid-cols-12 gap-y-8 lg:gap-x-12 items-start">
                <div className="col-span-12 lg:col-span-6 order-2 lg:order-1">
                    <Reveal>
                        <div className="group tech-frame relative overflow-hidden border border-vec-border aspect-[4/5] max-h-[560px] xl:max-h-[720px] w-full">
                            <img
                                src={IMAGES.about}
                                alt="VEC crane lifting a power transformer into position at a substation site"
                                loading="lazy"
                                className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-[1.03]"
                            />
                            <span className="absolute bottom-3 left-3 bg-vec-charcoal/85 text-white font-mono-tech text-[10px] uppercase tracking-[0.2em] px-3 py-1.5">
                                VEC Team — Field Execution
                            </span>
                        </div>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <div className="mt-4 flex items-center justify-between font-mono-tech text-[10px] uppercase tracking-[0.2em] text-vec-charcoal/45">
                            <span>Fig. 01 — Site Operations</span>
                            <span>Est. 1997</span>
                        </div>
                    </Reveal>
                </div>

                <div className="col-span-12 lg:col-span-6 order-1 lg:order-2">
                    <SectionHead
                        index="SEC 01"
                        eyebrow="About VEC"
                        title="Engineering Power Infrastructure Since 1997"
                    />
                    <Reveal delay={0.2}>
                        <p className="mt-6 text-base sm:text-lg leading-relaxed text-vec-charcoal font-medium max-w-xl">
                            Vijayanand Engineers &amp; Contractors is an electrical infrastructure
                            and power-sector contracting company delivering transmission, substation
                            and O&amp;M solutions.
                        </p>
                    </Reveal>
                    <Reveal delay={0.26}>
                        <p className="mt-4 text-base leading-relaxed text-vec-charcoal/60 max-w-xl">
                            Since 1997, our teams have planned, built, operated and maintained the
                            systems that keep power moving — combining engineering discipline with
                            practical field execution for utilities, renewable energy companies and
                            EPC partners.
                        </p>
                    </Reveal>

                    <div className="mt-7 border-t border-vec-border max-w-xl">
                        {QUICK_FACTS.map((f, i) => (
                            <Reveal key={f.k} delay={0.28 + i * 0.06}>
                                <div className="grid grid-cols-12 gap-3 py-3.5 border-b border-vec-border">
                                    <span className="col-span-4 sm:col-span-3 font-mono-tech text-[10px] uppercase tracking-[0.18em] text-vec-green pt-0.5">
                                        {f.k}
                                    </span>
                                    <span className="col-span-8 sm:col-span-9 text-sm leading-relaxed text-vec-charcoal/75">
                                        {f.v}
                                    </span>
                                </div>
                            </Reveal>
                        ))}
                    </div>

                    <Reveal delay={0.42}>
                        <div className="mt-6 max-w-xl border border-vec-border bg-vec-mist px-5 py-4">
                            <p className="font-mono-tech text-[10px] uppercase tracking-[0.22em] text-vec-green">
                                Technical Experience
                            </p>
                            <p className="mt-2 text-sm leading-relaxed text-vec-charcoal/80">
                                Experience across power infrastructure including substations up to{" "}
                                <span className="font-semibold text-vec-charcoal">400 kV</span> and
                                transmission lines up to <span className="font-semibold text-vec-charcoal">230 kV</span>.
                            </p>
                        </div>
                    </Reveal>
                </div>
            </div>

            <div
                className="mt-12 lg:mt-16 grid grid-cols-2 lg:grid-cols-4 gap-px bg-vec-border border border-vec-border"
                data-testid="stats-strip"
            >
                {STATS.map((s, i) => (
                    <Reveal key={s.label} delay={0.08 * i} className="bg-white">
                        <div className="h-full px-4 py-7 sm:py-9 text-center flex flex-col items-center justify-center">
                            <span className="font-mono-tech text-[10px] uppercase tracking-[0.24em] text-vec-green/80">
                                {s.over}
                            </span>
                            <span className="mt-1.5 font-display text-3xl sm:text-4xl lg:text-[2.6rem] font-bold text-vec-green tracking-tight leading-none">
                                <Counter
                                    value={s.value}
                                    prefix={s.prefix || ""}
                                    suffix={s.suffix || ""}
                                    plain={s.plain}
                                />
                            </span>
                            <span className="mt-2.5 font-mono-tech text-[10px] sm:text-[11px] uppercase tracking-[0.16em] text-vec-charcoal/60 leading-snug">
                                {s.label}
                            </span>
                        </div>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
